import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import type { ApiError } from '../types';
import { PolicyCountByStatus } from '../../types';

const END_POINT = '/metric/mfaPolicies';

type PolicyCountByStatusDto = PolicyCountByStatus;

const convertToMfaPolicyByStatus = (data: PolicyCountByStatusDto): PolicyCountByStatus => {
    return {
        total: data.total,
        active: data.active,
        disabled: data.disabled
    };
};

const fetchMfaPolicies = async (): Promise<PolicyCountByStatusDto> => {
    const data = await apiGet<PolicyCountByStatusDto>(`${API_BASE_URL}${END_POINT}`);
    return data;
};

export const useMfaPolicies = (): UseQueryResult<PolicyCountByStatus, ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.mfaPolicies(),
        queryFn: () => fetchMfaPolicies(),
        select: convertToMfaPolicyByStatus
    });
};
